import App from "@/App.vue";
import { initAccountModule } from "@/kibi/modules/account/account_module";
import { initAuditLogModule } from "@/kibi/modules/auditlog/audit_log_module";
import { initAuthModule } from "@/kibi/modules/auth/auth_module";
import { initDashboardModule } from "@/kibi/modules/dashboard/dashboard_module";
import { initEmailModule } from "@/kibi/modules/email/email_module";
import { initOrganizationModule } from "@/kibi/modules/organization/organization_module";
import { initProductModule } from "@/kibi/modules/product/product_module";
import { initProfileModule } from "@/kibi/modules/profile/profile_module";
import { initTemplateModule } from "@/kibi/modules/template/template_module";
import * as Sentry from "@sentry/vue";
import { createApp } from "vue";

// Plugins
import ability from "@/kibi/core/plugins/casl";
import i18n from "@/kibi/core/plugins/i18n";
import iconify from "@/kibi/core/plugins/iconify";
import layouts from "@/kibi/core/plugins/layouts";
import routerPlugin from "@/kibi/core/plugins/router";
import { router } from "@/kibi/core/plugins/router";
import pinia from "@/kibi/core/plugins/store/pinia";
import vuetify from "@/kibi/core/plugins/vuetify";
import webfontloader from "@/kibi/core/plugins/webfontloader";

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";

// Create vue app
const app = createApp(App);

// Initialize Sentry before mounting the app
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

// Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Register plugins manually
pinia(app);
vuetify(app);
routerPlugin(app);
layouts(app);
iconify();
webfontloader();
i18n(app);
ability(app);
app.use(Toast, {
  position: "top-right",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__fade",
});

// register modules
initAuthModule(app);
initDashboardModule(app);
initProfileModule(app);
initAccountModule(app);
initOrganizationModule(app);
initAuditLogModule(app);
initProductModule(app);
initTemplateModule(app);
initEmailModule(app);

// Mount vue app
app.mount("#app");
